export default "__VITE_ASSET__NyQ7Ej1G__"